import { render, staticRenderFns } from "./ejFxs.vue?vue&type=template&id=2259d1e9&scoped=true&"
import script from "./ejFxs.vue?vue&type=script&lang=js&"
export * from "./ejFxs.vue?vue&type=script&lang=js&"
import style0 from "./ejFxs.vue?vue&type=style&index=0&id=2259d1e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2259d1e9",
  null
  
)

export default component.exports